/**
 * Delivery channels for auth (OTP) codes, shared between API and clients.
 * Mirrors ev-backend/src/shared/enums/auth-delivery-channel.enum.ts.
 */
export enum AuthDeliveryChannel {
  TELEGRAM = 'telegram',
  SMS = 'sms',
  EMAIL = 'email',
}
